export default __webpack_public_path__ + "static/media/stanczyk.c9ec0e36.jpg";